import React from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'antd';
import cn from 'classnames';
import { paths } from '../../shared/configs/routing';
import styles from './index.module.scss';

const NotFoundPage = ({ className }) => {
  return (
    <div className={cn(styles.root, className)}>
      <Alert
        className={styles.errorMessage}
        type="error"
        message="Страница не найдена"
        description={
          <div className={styles.text}>
            <span>Возможно, ссылка более не актуальна, или в ней ошибка</span>
            <br />
            <Link
              to={(location) => ({ ...location, pathname: paths.main })}
              className={styles.link}
            >
              К списку приемок
            </Link>
          </div>
        }
        showIcon
      />
    </div>
  );
};

export default NotFoundPage;
